/**
 * @file NavbarPortal.tsx
 * @description Component for rendering the Navbar using React Portal.
 * This allows the Navbar to be mounted outside the main React app root.
 */

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Navbar from "./Navbar";

const NavbarPortal: React.FC = () => {
  const [navbarContainer, setNavbarContainer] = useState<Element | null>(null);

  useEffect(() => {
    const container = document.getElementById("site-navigation");
    if (container) {
      Array.from(container.children).forEach((child) => {
        (child as HTMLElement).style.display = "none";
      });
      setNavbarContainer(container);
    }
  }, []);

  if (!navbarContainer) return null;

  return createPortal(<Navbar />, navbarContainer);
};

export default NavbarPortal;
